import type { FC } from 'react';
import { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';

import { Player } from '@xing-com/crate-video-player';
import { Headline } from '@xing-com/typography';

import VideoEncodingIcon from '../../assets/upload-success.svg';

import * as Styled from './upload.styles';

const Encoding: FC = () => {
  return (
    <div className={'styles.uploadContainer'}>
      <Styled.UploadArea>
        <Styled.Illustration src={VideoEncodingIcon} />
        <Styled.EncodingTitle>
          <Headline size="large" noMargin>
            <FormattedMessage id={'VIDEO_UPLOAD_ENCODING_TITLE'} />
          </Headline>
        </Styled.EncodingTitle>
      </Styled.UploadArea>
    </div>
  );
};

type UploadFinishedProps = {
  videoId: string;
  previewImage?: File | string;
  onError?: () => void;
};
export const UploadFinished: FC<UploadFinishedProps> = ({
  videoId,
  previewImage,
  onError,
}) => {
  const [poster, setPoster] = useState<string | undefined>();

  useEffect(() => {
    if (previewImage) {
      setPoster(
        typeof previewImage === 'string'
          ? previewImage
          : URL.createObjectURL(previewImage)
      );
    }
  }, [previewImage]);

  return (
    <Styled.VideoContainer>
      <Player
        id={videoId}
        section="videoupload"
        encodingFallback={Encoding}
        previewModeAction={(disablePreviewMode: any) => disablePreviewMode()}
        posterImage={poster}
        onError={onError}
      />
    </Styled.VideoContainer>
  );
};
